import { render, staticRenderFns } from "./UnexpectedErrorModal.vue?vue&type=template&id=622ad855"
import script from "./UnexpectedErrorModal.vue?vue&type=script&lang=js"
export * from "./UnexpectedErrorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports